<template>
  <el-dialog
    :visible.sync="isVisible"
    :title="bp('sizingConfirmHeader')"
    :center="true"
    :show-close="true"
    :close-on-press-escape="true"
    :close-on-click-modal="false"
    :z-index="1000"
    qaid="p1-confirm-sizing-modal"
    @close="closeModal"
  >
    <template slot="title">
      <h1 v-html="bp('sizingConfirmHeader')" />
    </template>
    <span v-html="bp('sizingConfirmMessage')" />
    <template slot="footer">
      <div class="buttons buttons--center">
        <trek-button alert qaid="p1-add-to-cart-confirmation" @click="confirmAddToCart">
          <span v-html="bp('sizingYes')" />
        </trek-button>
        <trek-button secondary qaid="p1-open-sizing" @click="openSizing">
          <span v-html="bp('sizingNo')" />
        </trek-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';
import ElDialog from '@/components/Dialog';
import TrekButton from '@/components/TrekButton.vue';

export default {
  name: 'ProjectOneConfirmSizingModal',

  components: {ElDialog, TrekButton},

  computed: {
    isVisible: {
      get() {
        return this.isSizingModalVisible;
      },
      set(value) {
        this.setIsSizingModalVisible(value);
      },
    },

    ...mapState('projectOne', ['isSizingModalVisible']),
  },

  methods: {
    closeModal() {
      this.setIsSizingModalVisible(false);
    },

    confirmAddToCart() {
      this.addToCart();
      this.closeModal();
    },

    openSizing() {
      this.setToolbarDrawerOpenState(true);
      this.setToolbarDrawerCurrentTab('ProjectOneToolbarSizing');
      this.closeModal();
    },

    ...mapActions('projectOne', ['addToCart']),
    ...mapMutations('projectOne', [
      'setIsSizingModalVisible',
      'setToolbarDrawerOpenState',
      'setToolbarDrawerCurrentTab',
    ]),
  },
};
</script>
